// extracted by mini-css-extract-plugin
export default {"table":"vGI+R7DrTgvpJYO1pRW+1g==","BngUserCockpitConfDialog":"tg0IuOWkYmTPWrt++xR2AQ=="};